import { Component, ElementRef, ViewChild, AfterViewInit, HostListener, OnInit } from '@angular/core';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { FooterComponent } from '../../../shared/components/footer/footer.component';
import { HomeService } from '../../../shared/services/apis/platform/home.service';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { HomeBookStruct, HomeResponse } from '../../../shared/services/responses/platform/search-autocomplete.response copy';
import { RouterLink } from "@angular/router";
import { UtilService } from '../../../shared/services/util.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-home',
  imports: [
    MenuComponent,
    FooterComponent,
    RouterLink,
    MatIconModule
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent implements AfterViewInit, OnInit {

  // Captura os elementos do container de livros no template
  @ViewChild('mostSearchedContainer') mostSearchedContainer: ElementRef;
  @ViewChild('mostSoldContainer') mostSoldContainer: ElementRef;

  // Objeto para controlar o estado dos botões de cada slider
  public sliderStates: any = {
    mostSearched: { disablePrev: true, disableNext: false },
    mostSold: { disablePrev: true, disableNext: false }
  };

  constructor(private homeService: HomeService,
    private alertService: AlertService,
    public utilService: UtilService
  ) {

  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    this.populate();
  }

  public _homeResponse: HomeResponse;

  // Capas exibidas no leque da seção "Acervo completo" (usa os mais vendidos, com fallback para os mais buscados)
  public get catalogPreview(): HomeBookStruct[] {
    const source = this._homeResponse?.bestSellers?.length
      ? this._homeResponse.bestSellers
      : this._homeResponse?.mostSearched;

    return (source ?? []).filter(item => item.coverUrl).slice(0, 4);
  }

  populate() {
    this.homeService.get()
      .subscribe({
        next: (response: HomeResponse) => {
          if (response.isError) {
            this.alertService.show('Erro', response.errorDescription, AlertType.error);
            return;
          }
          this._homeResponse = response;

          console.log(response);
          // Após carregar os dados, precisamos re-verificar o estado dos botões
          // Usamos um setTimeout para garantir que o DOM foi atualizado
          setTimeout(() => this.onResize(), 100);
        },
        error: () => {
          this.alertService.show('Erro', 'Não foi possível carregar as informações da pagina', AlertType.error);
        }
      });
  }

  // Hook que é chamado depois que a view do componente é inicializada
  ngAfterViewInit() {
    this.checkScroll('mostSearched');
    this.checkScroll('mostSold');
  }

  // Ouve o evento de redimensionamento da janela para ajustar os botões
  @HostListener('window:resize')
  onResize() {
    this.checkScroll('mostSearched');
    this.checkScroll('mostSold');
  }

  private getElement(identifier: 'mostSearched' | 'mostSold'): HTMLElement {
    if (identifier === 'mostSearched') {
      return this.mostSearchedContainer.nativeElement;
    }
    return this.mostSoldContainer.nativeElement;
  }

  /**
   * Move o carrossel para a esquerda ou direita.
   * @param direction 'prev' para retroceder, 'next' para avançar.
   * @param identifier ID do slider ('mostSearched' ou 'mostSold').
   */
  public scroll(direction: 'prev' | 'next', identifier: 'mostSearched' | 'mostSold'): void {
    const element = this.getElement(identifier);
    if (element) {
      // Rola a largura visível do container, para um efeito de "página"
      const scrollAmount = element.clientWidth;
      element.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    }
  }

  /**
   * Verifica a posição do scroll para habilitar/desabilitar os botões de navegação.
   * @param identifier ID do slider ('mostSearched' ou 'mostSold').
   */
  public checkScroll(identifier: 'mostSearched' | 'mostSold'): void {
    const element = this.getElement(identifier);
    if (element) {
      const state = this.sliderStates[identifier];
      const { scrollLeft, scrollWidth, clientWidth } = element;

      // Desabilita o botão 'prev' se estiver no início
      state.disablePrev = scrollLeft <= 0;

      // Desabilita o botão 'next' se estiver no fim (com uma pequena tolerância)
      state.disableNext = scrollLeft + clientWidth >= scrollWidth - 1;
    }
  }

  public scrollToPublish(): void {
    const element = document.getElementById('publish-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}